<app-card-content [border]="false" [title]="'Funcionários'" [icon]="'pi pi-id-card'" [subtitle]="'Cadastro de funcionários da instituição'">
    <div card-header>
        <p-button label="Novo Funcionário" icon="pi pi-plus" size="small" (onClick)="novoFuncionario()" [appCan]="roleFuncionariosCriar" />
    </div>

    <!-- ── Filtros ────────────────────────────────────────────────────────── -->
    <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
        <app-filtro-campo label="Nome, CPF ou matrícula" [wide]="true" inputId="funcionarios-filtro-texto">
            <input
                id="funcionarios-filtro-texto"
                pInputText
                type="text"
                class="w-full"
                placeholder="Ex.: Maria, 123.456.789-00 ou 4521..."
                [ngModel]="filtroTexto()"
                (ngModelChange)="filtroTexto.set($event)"
                (keyup.enter)="aplicarFiltros()"
            />
        </app-filtro-campo>
        <app-filtro-campo label="UF">
            <app-estado-select class="w-full" [uf]="filtroUf()" [disabled]="ufTravada()" (ufChange)="onEstadoChange($event)" />
        </app-filtro-campo>
    </app-filtros-bar>

    <div class="flex items-center justify-end gap-3 mb-4">
        <span class="contador-label">{{ total() }} encontrados</span>
        <app-table-view-switcher [(viewMode)]="currentView" />
    </div>

    <!-- ── Vista CARDS ────────────────────────────────────────────────────── -->
    @if (currentView() === 'card') {
        @if (carregando()) {
            <div class="flex justify-center py-12">
                <i class="pi pi-spin pi-spinner text-3xl text-muted-color"></i>
            </div>
        } @else if (itens().length === 0) {
            <div class="estado-vazio">
                <div class="estado-vazio-icone"><i class="pi pi-id-card"></i></div>
                <p class="estado-vazio-titulo">Nenhum funcionário encontrado</p>
                <p class="estado-vazio-subtitulo">
                    @if (temFiltrosAtivos) {
                        Tente ajustar os filtros aplicados.
                    } @else {
                        Cadastre o primeiro funcionário.
                    }
                </p>
                @if (temFiltrosAtivos) {
                    <p-button label="Limpar filtros" severity="secondary" size="small" (onClick)="limparFiltros()" class="mt-2" />
                }
            </div>
        } @else {
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
                @for (item of itens(); track item.uf + '|' + item.idSolicitante) {
                    <app-card-container class="flex flex-col h-full">
                        <div class="flex flex-col gap-3 h-full">
                            <!-- Topo: UF + situação -->
                            <div class="flex items-start justify-between gap-2 shrink-0">
                                <span class="id-tabela">{{ item.uf }}</span>
                                <div class="flex gap-1">
                                    @if (ehAgenteAgr(item)) {
                                        <p-tag severity="info" value="AGR" [rounded]="true" styleClass="text-xs" pTooltip="Agente de Registro" />
                                    }
                                    <p-tag [severity]="situacaoSeverity(item)" [value]="situacaoLabel(item)" [rounded]="true" styleClass="text-xs" />
                                </div>
                            </div>

                            <div class="flex items-center gap-2 shrink-0">
                                <app-pessoa-avatar [foto]="null" [iniciais]="iniciaisDe(item)" [nome]="item.nome || ''" tamanho="xxl" />
                                <h3 class="descricao-titulo">{{ item.nome || '—' }}</h3>
                            </div>
                            <div class="divisor-acento shrink-0"></div>

                            <div class="grid grid-cols-2 gap-x-4 gap-y-3 flex-grow">
                                <div class="info-campo">
                                    <span class="info-rotulo">CPF</span>
                                    <span class="info-valor font-mono">{{ cpfFormatado(item.cpf) }}</span>
                                </div>
                                <div class="info-campo">
                                    <span class="info-rotulo">Matrícula</span>
                                    <span class="info-valor font-mono">{{ item.nuMatricula || '—' }}</span>
                                </div>
                                <div class="info-campo">
                                    <span class="info-rotulo">Cargo</span>
                                    <span class="info-valor truncate">{{ item.dsCargo || '—' }}</span>
                                </div>
                                <div class="info-campo">
                                    <span class="info-rotulo">Lotação</span>
                                    <span class="info-valor truncate">{{ item.dsEstruturaOrganizacional || '—' }}</span>
                                </div>
                            </div>

                            <div class="card-rodape shrink-0 mt-auto justify-start items-center">
                                @if (ehAfastado(item)) {
                                    <span class="afastamento-badge"><i class="pi pi-calendar-times mr-1"></i>Afastado em {{ dataFormatada(item.dtAfastamento) }}</span>
                                }
                                <div class="ml-auto flex gap-2">
                                    <p-button icon="pi pi-pencil" [text]="true" size="small" pTooltip="Editar" (onClick)="editarFuncionario(item)" [appCan]="roleFuncionariosEditar" />
                                </div>
                            </div>
                        </div>
                    </app-card-container>
                }
            </div>
        }
    }

    <!-- ── Vista TABELA ───────────────────────────────────────────────────── -->
    @if (currentView() === 'table') {
        <p-table [value]="itens()" [loading]="carregando()" class="p-datatable-sm" stripedRows [rowHover]="true" [tableStyle]="{ 'min-width': '60rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>Nome</th>
                    <th style="width: 140px">CPF</th>
                    <th style="width: 100px">Matrícula</th>
                    <th>Cargo</th>
                    <th>Lotação</th>
                    <th class="text-center" style="width: 70px">UF</th>
                    <th class="text-center" style="width: 150px">Situação</th>
                    <th class="text-center" style="width: 90px">Ações</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="linha-tabela">
                    <td>
                        <div class="flex items-center gap-1.5">
                            <app-pessoa-avatar [foto]="null" [iniciais]="iniciaisDe(item)" [nome]="item.nome || ''" tamanho="xxl" />
                            <span class="font-semibold text-sm">{{ item.nome || '—' }}</span>
                        </div>
                    </td>
                    <td class="font-mono text-sm">{{ cpfFormatado(item.cpf) }}</td>
                    <td class="font-mono text-sm">{{ item.nuMatricula || '—' }}</td>
                    <td class="text-sm">{{ item.dsCargo || '—' }}</td>
                    <td class="text-sm">{{ item.dsEstruturaOrganizacional || '—' }}</td>
                    <td class="text-center">
                        <span class="id-tabela">{{ item.uf }}</span>
                    </td>
                    <td class="text-center">
                        <div class="flex justify-center gap-1">
                            @if (ehAgenteAgr(item)) {
                                <p-tag severity="info" value="AGR" [rounded]="true" pTooltip="Agente de Registro" />
                            }
                            <p-tag [severity]="situacaoSeverity(item)" [value]="situacaoLabel(item)" [rounded]="true" />
                        </div>
                    </td>
                    <td class="text-center">
                        <div class="flex justify-center gap-1">
                            <p-button icon="pi pi-pencil" size="small" severity="secondary" [text]="true" pTooltip="Editar" tooltipPosition="top" (onClick)="editarFuncionario(item)" [appCan]="roleFuncionariosEditar" />
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">
                        <div class="estado-vazio">
                            <div class="estado-vazio-icone"><i class="pi pi-id-card"></i></div>
                            <p class="estado-vazio-titulo">Nenhum funcionário encontrado</p>
                            <p class="estado-vazio-subtitulo">
                                @if (temFiltrosAtivos) {
                                    Tente ajustar os filtros aplicados.
                                } @else {
                                    Cadastre o primeiro funcionário.
                                }
                            </p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    }

    <!-- ── Paginação compartilhada (cards + tabela) ───────────────────────── -->
    <!-- Paginação é do servidor: a condição olha o total, não o tamanho da página carregada. -->
    @if (total() > itensPorPagina()) {
        <p-paginator
            [first]="primeiroItem"
            [rows]="itensPorPagina()"
            [totalRecords]="total()"
            [rowsPerPageOptions]="[20, 50, 100]"
            (onPageChange)="onPaginacaoMudar($event)"
            styleClass="mt-4 border-t border-surface-200 dark:border-surface-700"
        />
    }
</app-card-content>

<app-funcionario-detalhe [chave]="funcionarioSelecionado()" [(showDialog)]="modalDetalhe" (salvo)="onSalvo()" (agrAlterado)="carregar()" />
